import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Button } from 'reactstrap';
import { connect } from 'react-redux';

import './UserProfile.scss';

import commonConStant from '../../common/_commonConstant';
import { isCashier, Modal } from '../../helpers';
import { Loading } from '../../components';
import { fetchUpdateProfilePassword } from '../../actions';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'loading': false,
      'newPassword': null,
      'confirmNewPassword': null,
      'isSuccess': false,
      'isNotMatch': false,
      'isUnder': false,
      'currentPassword': '',
      'currentPasswordError': false,
    };
  }

  UNSAFE_componentWillReceiveProps() {
    const { show } = this.props;
    if (!show) {
      return this.setState({ 'isSuccess': false, 'newPassword': '', 'confirmNewPassword': '' });
    }
  }

  componentDidUpdate(prevProps) {
    const { updateProfile } = this.props;

    if (updateProfile && updateProfile !== prevProps.updateProfile) {
      if (updateProfile.password) {
        return this.setState({ 'isSuccess': true });
      }

      switch (updateProfile.reason) {
        case commonConStant.userProfileCurrentPassword:
          return this.setState({ 'currentPasswordError': true });
        case commonConStant.userProfileNewPassword:
          return this.setState({ 'isUnder': true });
        default:
          return null;
      }
    }
  }

  handleBodyModal = () => {
    const { getProfile, handleCloseModal } = this.props;
    const {
      newPassword,
      confirmNewPassword,
      isNotMatch,
      isUnder,
      isSuccess,
      currentPassword,
      currentPasswordError,
    } = this.state;

    if (!getProfile) {
      return null;
    }
    return (
      <div className="user-profile">
        {
          isSuccess ?
            <div className="user-profile-success">
              <div className="icon icon-user-password">
                <span className="path1"/><span className="path2"/>
              </div>
              <div className="user-profile-success-title">password updated!</div>
              <div className="user-profile-button-box">
                <Button
                  id="close-btn"
                  className="btn-primary btn-user"
                  onClick={handleCloseModal}
                >OK</Button>
              </div>
            </div>
            : <div>
              <div className="user-profile-current-title">Current password</div>
              <Input
                id="current-password"
                type="password"
                className={`user-profile-input ${currentPasswordError ? 'input-in-valid' : ''}`}
                placeholder="enter current password"
                value={currentPassword}
                onChange={event => this.handleState('currentPassword', event.target.value)}
              />
              {currentPasswordError ? this.handleErrorMessage('password ไม่ถูกต้อง') : null}
              <div className="user-profile-new-title">New password</div>
              <Input
                id="new-password"
                type="password"
                className={`user-profile-input ${isNotMatch || isUnder ? 'input-in-valid' : ''}`}
                placeholder="enter new password at least 8 characters"
                onChange={event => this.handleChange(event, 'newPassword')}
                value={newPassword}
              />
              <div className="user-profile-confirm-title">Confirm new password</div>
              <div className="user-profile-confirm-box">
                <Input
                  id="confirm-new-password"
                  type="password"
                  className={`user-profile-input ${isNotMatch || isUnder ? 'input-in-valid' : ''}`}
                  placeholder="enter new password at least 8 characters"
                  onChange={event => this.handleChange(event, 'confirmNewPassword')}
                  value={confirmNewPassword}
                />
                {isUnder ? this.handleErrorMessage('password ขั้นต่ำ 8 ตัวอักษร') : null}
                {isNotMatch ? this.handleErrorMessage('password ไม่ตรงกัน') : null}
              </div>
              <div className="user-profile-button-box">
                <Button id="confirm-change-btn" className="btn-primary btn-confirm" onClick={this.handleConfirm}>confirm</Button>
              </div>
            </div>
        }
      </div>
    );
  }

  handleChange = (event, state) => this.setState({ [state]: event.target.value, 'isNotMatch': false, 'isUnder': false });

  handleErrorMessage = message => <div className="in-valid">{message}</div>;


  handleConfirm = () => {
    const { newPassword, confirmNewPassword, currentPassword } = this.state;

    if (!currentPassword) {
      this.setState({ 'currentPasswordError': true });
    }

    if (newPassword && newPassword.length >= 8 && confirmNewPassword && confirmNewPassword.length >= 8) {
      if (newPassword === confirmNewPassword) {
        return this.props.dispatch(fetchUpdateProfilePassword(currentPassword, newPassword));
      }
      return this.setState({ 'isNotMatch': true });
    }
    return this.setState({ 'isUnder': true });
  }

  handleState = (state, val) => this.setState({ [state]: val, [`${state}Error`]: false });

  render() {
    const { loading } = this.state;
    const { show, handleCloseModal, getProfile } = this.props;
    return (
      <Modal x2={isCashier(getProfile)} show={show ? true : false} header="Edit my password" handleToggle={handleCloseModal}>
        {loading ? <Loading /> : null}
        <div className={`UserProfile${isCashier(getProfile) ? ' x2' : ''}`}>
          {this.handleBodyModal()}
        </div>
      </Modal>
    );
  }
}

UserProfile.propTypes = {
  'show': PropTypes.bool.isRequired,
  'handleCloseModal': PropTypes.func,
  'getProfile': PropTypes.shape({
    'userRole': PropTypes.shape({
      'userRoleName': PropTypes.string.isRequired,
    }),
  }),
  'dispatch': PropTypes.func,
  'updateProfile': PropTypes.shape({
    'password': PropTypes.string,
    'reason': PropTypes.string,
  }),
};

const mapStateToProps = ({ getProfile, updateProfile }) => ({
  'getProfile': getProfile.data,
  'updateProfile': updateProfile.data,
});

export default connect(mapStateToProps)(UserProfile);
